// extracted by mini-css-extract-plugin
export default {"faqContainer":"FAQ_faqContainer__XBMMK","faqItem":"FAQ_faqItem__MQW6H","question":"FAQ_question__BGtCA","answer":"FAQ_answer__CV9+y","toggleIcon":"FAQ_toggleIcon__GAnSm"};